import UserProfileForm from "./Profile"

export default function UserProfile() {
  return (
        <UserProfileForm />
  )
}

